import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center">
        <h1 className="font-serif text-4xl text-white mb-4">Artículo no encontrado</h1>
        <Link to="/blog" className="text-[#D4AF37]">Volver al blog</Link>
      </div>
    );

  if (!post) return <div className="text-center py-32 text-zinc-500">Cargando…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-12 py-24">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-[#D4AF37] mb-10">
        <ArrowLeft className="w-4 h-4" /> Volver al blog
      </Link>
      <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] mb-4">{post.category}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-white leading-tight mb-6">{post.title}</h1>
      <p className="text-lg text-zinc-400 mb-10">{post.excerpt}</p>
      {post.cover_image && (
        <img src={post.cover_image} alt={post.title} className="w-full rounded-2xl mb-10" />
      )}
      <div className="prose prose-invert max-w-none">
        {post.content.split("\n\n").map((para, i) => (
          <p key={i} className="text-zinc-300 leading-relaxed mb-6 text-lg">
            {para}
          </p>
        ))}
      </div>
    </article>
  );
}
